import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterMecanicosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Mecanico/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarMecanicoAsync = async (nome, idCargo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome: normalizeTextUppercase(nome), idCargo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Mecanico`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarMecanicoAsync = async (id, nome, idCargo, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome: normalizeTextUppercase(nome), idCargo, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Mecanico/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
